import React from 'react';

const svgStyles: React.CSSProperties = {
	position: 'absolute',
	top: 0,
	left: 0,
	pointerEvents: 'none',
};

const Icons: React.FC = () => (
	<>
		<svg style={svgStyles} xmlns="http://www.w3.org/2000/svg">
			<defs>
				{/*region node icons*/}
				<g id="application-collaboration" viewBox="0 0 30 30">
					<circle
						cx={13}
						cy={15}
						r={6}
						fill="transparent"
						stroke="black"
						strokeWidth=".8px"
					/>
					<circle
						cx={18}
						cy={15}
						r={6}
						fill="transparent"
						stroke="black"
						strokeWidth=".8px"
					/>
				</g>
				<g id="application-component" viewBox="0 0 30 30">
					<rect
						x={12.5}
						y={9}
						width={8}
						height={12}
						stroke="black"
						strokeWidth=".8px"
						fill="#B5FFFF"
					></rect>
					<rect
						x={9.5}
						y={12}
						width={6}
						height={2}
						stroke="black"
						strokeWidth=".8px"
						fill="#B5FFFF"
					></rect>
					<rect
						x={9.5}
						y={16}
						width={6}
						height={2}
						stroke="black"
						strokeWidth=".8px"
						fill="#B5FFFF"
					></rect>
				</g>
				<path
					id="application-event"
					d="M4.5 20 A5 5 0 1 0 4.5 10 L21.5 10 A5 5 0 1 1 21.5 20 L4.6 20"
					viewBox="0 0 30 30"
					fill="transparent"
					stroke="black"
					strokeWidth=".8px"
				/>
				<path
					id="application-function"
					d="M7 12 L15 7 L23 12 L23 22 L15 17 L7 22 L7 12"
					viewBox="0 0 30 30"
					fill="transparent"
					stroke="black"
					strokeWidth=".8px"
				/>
				<path
					id="application-interface"
					d="M7 15 L13 15 M18 10 A5 5 41 1 1 17.9 10"
					viewBox="0 0 30 30"
					fill="transparent"
					stroke="black"
					strokeWidth=".8px"
				/>
				<path
					id="application-process"
					d="M7 12 L16 12 L16 7 L23 15 L16 23 L16 18 L7 18 L7 12"
					viewBox="0 0 30 30"
					fill="transparent"
					stroke="black"
					strokeWidth=".8px"
				/>
				<g id="application-interaction" transform="translate(6 6)">
					<path
						d="m 10.5 2 q 6 0 6 7 q 0 7 -6 7 z m -3 14 q -6 0 -6 -7 q 0 -7 6 -7 z"
						fill="#B5FFFF"
						stroke="black"
						strokeWidth=".8px"
					/>
				</g>
				<rect
					id="application-service"
					x={7}
					y={10}
					width={16}
					height={10}
					ry={5}
					viewBox="0 0 30 30"
					fill="transparent"
					stroke="black"
					strokeWidth=".8px"
				/>
				<g id="application-data-object" transform="translate(6 6)">
					<path
						d="m 1.5 2.5 l 15 0 l 0 13 l -15 0 z m 0 4 l 15 0"
						fill="#B5FFFF"
						stroke="black"
						strokeWidth=".9px"
					/>
				</g>
				{/*endregion node icons*/}
				<marker
					id="archimate-composition"
					markerWidth="12"
					markerHeight="12"
					viewBox="0 -6 12 12"
					refX="0"
					refY="0"
					orient="auto"
				>
					<polygon
						points="0,0 6,-4 12,0 6,4"
						fill="black"
						stroke="black"
						strokeWidth={1}
					/>
				</marker>
				<marker
					id="archimate-aggregation"
					markerWidth="12"
					markerHeight="12"
					viewBox="0 -6 12 12"
					refX="0"
					refY="0"
					orient="auto"
				>
					<polygon
						points="0,0 6,-4 12,0 6,4"
						fill="white"
						stroke="black"
						strokeWidth={1}
					/>
				</marker>
				<marker
					id="archimate-realization"
					markerWidth="12"
					markerHeight="12"
					viewBox="-6 -6 12 12"
					refX="0"
					refY="0"
					orient="auto"
				>
					<polygon
						points="-5,-5 -0.5,0 -5,5"
						fill="white"
						stroke="black"
						strokeWidth={1}
					/>
				</marker>
				<marker
					id="archimate-assignment-start"
					markerWidth="6"
					markerHeight="6"
					viewBox="0 -3 6 6"
					refX="0"
					refY="0"
					orient="auto"
				>
					<circle cx={3} cy={0} r={2.5} fill="black" stroke="black" strokeWidth={1} />
				</marker>
				<path
					id="file"
					fill="white"
					d="M15,22H3a2.006,2.006,0,0,1-2-2V4A2.006,2.006,0,0,1,3,2H9a1.007,1.007,0,0,1,.73.32l6.92,6.94A.954.954,0,0,1,17,10V20A2.006,2.006,0,0,1,15,22ZM10,5.42V9.01h3.58Zm5,5.59H9a1,1,0,0,1-1-1V4H3V20H15ZM7,13h4a1,1,0,0,1,0,2H7a1,1,0,0,1,0-2Zm0,3h4a1,1,0,0,1,0,2H7a1,1,0,0,1,0-2Z"
				/>
				<g id="import">
					<path d="M0,0H24V24H0Z" fill="none" />
					<path
						d="M17331.994-133a.994.994,0,0,1-.992-1v-5a.994.994,0,0,1,.992-1,1,1,0,0,1,1,1v4h14v-4a1.006,1.006,0,0,1,1.006-1,1,1,0,0,1,1,1v5a1,1,0,0,1-1,1Zm7.3-5.029-3.539-3.531a1.015,1.015,0,0,1,0-1.415,1,1,0,0,1,1.416,0l1.828,1.824V-152a1,1,0,0,1,1-1,1,1,0,0,1,1,1v10.9l1.873-1.872a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.415l-3.535,3.531a1,1,0,0,1-.705.3h-.039A.994.994,0,0,1,17339.291-138.027Z"
						transform="translate(-17330 154.999)"
						fill="black"
					/>
				</g>
				<g id="export">
					<path d="M0,0H24V24H0Z" fill="none" />
					<path
						d="M17331.994-133a.994.994,0,0,1-.992-1v-5a.994.994,0,0,1,.992-1,1,1,0,0,1,1,1v4h14v-4a1.006,1.006,0,0,1,1.006-1,1,1,0,0,1,1,1v5a1,1,0,0,1-1,1Zm7.006-5.734v-10.85l-1.828,1.829a1.008,1.008,0,0,1-1.416,0,1,1,0,0,1,0-1.415l3.535-3.535a1.01,1.01,0,0,1,.729-.3,1,1,0,0,1,.73.3l3.535,3.535a1,1,0,0,1,0,1.415,1,1,0,0,1-1.414,0L17341-149.63v10.9a1,1,0,0,1-1,1A1,1,0,0,1,17339-138.732Z"
						transform="translate(-17330 154.999)"
						fill="black"
					/>
				</g>
			</defs>
		</svg>
	</>
);

export default Icons;
